//@flow

type Option = {
  id: any,
  value: any,
  text?: string,
  name?: string,
  label: ?string,
  options?: Array<Option>,
  children?: Array<Option>,
};

// note that this function mutates directly!
const fixKeys = (options: ?Array<Option>) => {
  if (options && Array.isArray(options)) {
    options.forEach((option) => {
      if (option.hasOwnProperty('text') || option.hasOwnProperty('name')) {
        option.value = option.id;
        option.label = option.text || option.name;
        option.options = option.children;

        if (option.options && option.options.length > 0) {
          fixKeys(option.options);
        }
      }
    });

    return options;
  }
};

function isEmpty(str) {
  return !str || str.length === 0;
}

function matchesFilter(option: Option, filter: string) {
  if (isEmpty(filter)) {
    return true;
  }

  return (
    option.label && option.label.toLowerCase().includes(filter.toLowerCase())
  );
}

const copyOptions = (input: Array<Object> | Object): Array<Object> | Object => {
  if (typeof input !== 'object' || input === null) {
    return input;
  }

  const outObject = Array.isArray(input) ? [] : {};

  // $FlowFixMe for const in is okay for arrays
  for (const key in input) {
    if (!input.hasOwnProperty(key)) continue;

    // $FlowFixMe we check property above
    const value = input[key];
    // $FlowFixMe we check property above
    outObject[key] = copyOptions(value);
  }

  return outObject;
};

// note that this function mutates directly as well, copy options first if needed
const filterOptions = (
  options: Array<Option> = [],
  filter: string,
  currentValues: Array<Option>
) => {
  if (!options) {
    return [];
  }

  // $FlowFixMe
  return options.filter((option) => {
    const matchingChildren = filterOptions(
      option.options,
      filter,
      currentValues
    );

    const hasMatchingChildren = matchingChildren && matchingChildren.length > 0;

    if (hasMatchingChildren) {
      option.options = matchingChildren;
    }

    const currentlySelected = currentValues
      ? currentValues.some((cv) => cv.value === option.value)
      : false;

    return (
      (matchesFilter(option, filter) || hasMatchingChildren) &&
      !currentlySelected
    );
  });
};

const DROPDOWN_SELECTORS = {
  container: 'div.sl-dropdown-container',
  controller: 'div.sl-dropdown__control',
  clear_indicator: 'div.sl-dropdown__clear-indicator',
  arrow_indicator: 'div.sl-dropdown__dropdown-indicator',
  is_disabled: 'div.sl-dropdown--is-disabled',
  is_open: 'div.sl-dropdown__control--menu-is-open',
  placeholder_text: 'div.sl-dropdown__placeholder',
  selected_value: 'div.sl-dropdown__single-value',
  multi_selected_values: 'span[data-provides="chip-text"]',
  option: 'div.sl-dropdown__option',
  focused_option: 'div.sl-dropdown__option--is-focused',
  selected_option: 'div.sl-dropdown__option--is-selected',
  disabled_option: 'div.sl-dropdown__option--is-disabled',
  no_options_message: 'div.sl-dropdown__menu-notice--no-options',
  loading_message: 'div.sl-dropdown__menu-notice--loading',
};
const LEGACY_SELECT_SELECTORS = {
  container: 'div.Select',
  controller: 'div.Select-control',
  clear_indicator: 'div.Select-clear',
  arrow_indicator: 'div.Select .Select-arrow-zone',
  is_disabled: 'div.Select.is-disabled',
  is_open: 'div.Select.is-open',
  placeholder_text: 'div.Select-placeholder',
  selected_value: 'div.Select-value-label',
  multi_selected_values:
    'span[data-test-role="react-chosen-multiselect-option"]',
  option: 'div.Select-option',
  focused_option: 'div.Select-option.is-focused',
  selected_option: 'div.Select-option.is-selected',
  disabled_option: 'div.Select-option.is-disabled',
  no_options_message: 'div.Select-no-options',
  loading_message: 'div.Select-loading',
};

const VIRTUALIZED_SELECTORS = {
  ...LEGACY_SELECT_SELECTORS,
  option: 'div.VirtualizedSelectOption',
  focused_option: 'div.VirtualizedSelectSelectedOption',
  selected_option: 'div.VirtualizedSelectFocusedOption',
  disabled_option: 'div.VirtualizedSelectDisabledOption',
};

export {
  fixKeys,
  filterOptions,
  DROPDOWN_SELECTORS,
  LEGACY_SELECT_SELECTORS,
  VIRTUALIZED_SELECTORS,
  copyOptions,
};
